import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onFileValidationData", "onClickButton", "canEditInvoice"];
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { actions } from '../../constants/actions';
import ChargePaymentMethodTooltip from '../chargePaymentMethod/ChargePaymentMethodTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
function ChargePaymentMethodActionButton(_ref) {
  let {
      onFileValidationData,
      onClickButton,
      canEditInvoice
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ChargePaymentMethodTooltip, {
    onFileValidationData: onFileValidationData,
    canEditInvoice: canEditInvoice,
    openInvoiceEditor: () => onClickButton(actions.EDIT),
    placement: "bottom",
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "charge-payment-method-btn",
      disabled: buttonProps.disabled,
      use: "tertiary-light",
      responsive: false,
      size: "extra-small",
      onClick: () => {
        onClickButton(actions.CHARGE_PAYMENT_METHOD);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.buttons.chargePaymentMethod"
      })
    }, "charge-payment-method-btn")
  });
}
export default ChargePaymentMethodActionButton;